var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.994 7.242A6.067 6.067 0 0 0 3.334 4.18v-.848l-.005-.077A.667.667 0 0 0 2 3.333V6l.005.078c.038.331.32.589.662.589h2.666l.078-.005A.667.667 0 0 0 6.001 6l-.005-.078a.667.667 0 0 0-.663-.589H4.127a4.734 4.734 0 0 1 8.546 2.092.667.667 0 0 0 1.32-.183ZM7.41 12.618a4.733 4.733 0 0 1-4.083-4.043.667.667 0 0 0-1.32.183 6.067 6.067 0 0 0 10.66 3.06v.849l.004.077a.667.667 0 0 0 1.33-.077V10l-.005-.078a.667.667 0 0 0-.663-.589h-2.666l-.078.005A.667.667 0 0 0 10 10l.005.078c.038.331.32.589.662.589h1.206a4.734 4.734 0 0 1-4.463 1.95Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.7500a5a8bb1d69a17634fa88503023e7.svg";
export { ForwardRef as ReactComponent };